require('./angular-sanitize');
module.exports = 'ngSanitize';



//////////////////
// WEBPACK FOOTER
// ../~/angular-sanitize/index.js
// module id = 366
// module chunks = 1